import { produce } from "immer";
import { navigationActions } from "./navigationActions";
import { SET_MENU_OPTION, DIALOG_OPEN, ROUTER_PAYLOAD_UPDATER, SET_MENU_DRAWER, SET_IS_MOBILE, SET_SIGNUP_POPUP } from "./navigationConstant";
import { InitialNavigationState, MenuOptionType } from "./navigationModels";

const initialNavigationState: InitialNavigationState = {
  currentMenuOption: "Menu",
  modal_open: false,
  showMenuDrawer: false,
  routerPayloads:null,
  isMobile:window.innerWidth <= 768,
  showSignupPopup: false,
};
export default function tinyURLReducer(
  state: InitialNavigationState = initialNavigationState,
  action: navigationActions
) {
  return produce(state, (draft) => {
    switch (action.type) {
      case SET_MENU_OPTION:
        draft.currentMenuOption = action.payload as MenuOptionType;
        break;
        
      case DIALOG_OPEN:
        draft.modal_open = action.payload;
        break;

      case ROUTER_PAYLOAD_UPDATER:
        draft.routerPayloads = action.payload;
        break;  

      case SET_MENU_DRAWER:
        draft.showMenuDrawer = action.payload;
        break;

      case SET_IS_MOBILE:       
        draft.isMobile=action.payload
        break;

      case SET_SIGNUP_POPUP:
        draft.showSignupPopup = action.payload;
        break;
        
      default:
        break;
    }
  });
}
